import { prefixObjectValues } from '../../utils';
const form = {
  id: 'form',
  socialSecurityNumInput: 'socialSecurityNumInput',
  driversNumInput: 'driversInput',
  driversStateSelect: 'driversStateSelect',
  passportNum: 'passportNumInput',
  cancelBtn: 'cancelBtn',
  updateBtn: 'updateBtn',
  submitBtn: 'submitBtn',
};

export default prefixObjectValues(form, 'profile-sensitive-info-form');
